export default "__VITE_ASSET__1333bc08__"